"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiHost = exports.host = void 0;
exports.host = window.document.location.origin.includes("localhost")
    ? "http://localhost:44567"
    : window.document.location.origin;
exports.apiHost = exports.host + "/api";
